import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import './Footer.css';
import cael from '../Assets/cael.png';

const SUPPORT_EMAIL = 'hello@st-cael.org';

const Footer = () => {
  const { t } = useTranslation('footer');
  const year = new Date().getFullYear();

  const links = [
    { label: t('links.privacy'), to: '/privacy' },
    { label: t('links.about'), to: '/about' },
    { label: t('links.howTo'), to: '/how-to' },
    { label: t('links.feedback'), to: '/feedback' },
  ];

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand-block">
          <Link to="/" className="footer-brand" aria-label="St Cael Vog">
            <img src={cael} alt="" />
          </Link>
          <div className="footer-accent" aria-hidden />
          <p className="footer-tagline">{t('tagline')}</p>
        </div>

        <div className="footer-meta-block">
          <nav className="footer-nav" aria-label={t('navLabel')}>
            {links.map((link, index) => (
              <React.Fragment key={link.to}>
                {index > 0 && <span className="footer-dot" aria-hidden>·</span>}
                <Link to={link.to}>{link.label}</Link>
              </React.Fragment>
            ))}
          </nav>

          <div className="footer-utils">
            <a href={`mailto:${SUPPORT_EMAIL}`} className="footer-contact">
              <Mail size={16} aria-hidden />
              {SUPPORT_EMAIL}
            </a>
          </div>

          <p className="footer-copy">{t('copyright', { year })}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
